export default __webpack_public_path__ + "static/garden_design26-5a0659ee32b4245cb3ac22bc5bbbf288.webp";